import type { RouteRecordRaw } from "vue-router";
import { routeNames } from "@/router/constants";
import { useIntl } from "@moroku/money-webapp-components";

const { t } = useIntl();

export const getBusinessOnboardingRoutes = (): RouteRecordRaw[] => [
  {
    path: "/business-onboarding",
    name: routeNames.BUSINESS_ONBOARDING_VIEW,
    component: () => import("@/features/Onboarding/OnboardingBusinessView.vue"),
    meta: {
      title: t("onboarding_kyc_title"),
      headerBottomMargin: false,
    },
  },
];
